const Settings =  {
    app_version: '1.4.4',
    push_time: '30.07.2026, 20:06'
}
export default Settings
